<template>
	<div class="protocol-list-container">
		<!-- 搜索区域 -->
		<el-card class="search-card" shadow="never">
			<!-- 页面标题 -->
			<div class="page-title">
				协议列表
			</div>

			<div class="search-form">
				<!-- 第一行查询条件 -->
				<div class="search-row">
					<div class="search-item">
						<label class="search-label">投标企业</label>
						<div class="search-control">
							<el-select v-model="searchForm.bidCompany" placeholder="请选择" clearable filterable>
								<el-option label="山东高速信联科技股份有限公司" value="山东高速信联科技股份有限公司" />
								<el-option label="其他企业" value="其他企业" />
							</el-select>
						</div>
					</div>

					<div class="search-item">
						<label class="search-label">协议类型</label>
						<div class="search-control">
							<el-select v-model="searchForm.protocolType" placeholder="请选择" clearable>
								<el-option label="签约协议" value="签约协议" />
								<el-option label="其他类型" value="其他类型" />
							</el-select>
						</div>
					</div>

					<div class="search-item">
						<label class="search-label">协议状态</label>
						<div class="search-control">
							<el-select v-model="searchForm.protocolStatus" placeholder="请选择" clearable>
								<el-option label="待签约" value="待签约" />
								<el-option label="已签约" value="已签约" />
								<el-option label="签约失败" value="签约失败" />
								<el-option label="已解约" value="已解约" />
							</el-select>
						</div>
					</div>

					<div class="search-item">
						<label class="search-label">方案名称</label>
						<div class="search-control">
							<el-select v-model="searchForm.programName" placeholder="请选择" clearable>
								<el-option label="信联5座2个月" value="信联5座2个月" />
								<el-option label="其他方案" value="其他方案" />
							</el-select>
						</div>
					</div>

					<div class="search-item">
						<label class="search-label">订单编号</label>
						<div class="search-control">
							<el-input v-model="searchForm.orderNo" placeholder="订单编号" clearable />
						</div>
					</div>
				</div>

				<!-- 第二行查询条件 -->
				<div class="search-row">
					<div class="search-item">
						<label class="search-label">协议号</label>
						<div class="search-control">
							<el-input v-model="searchForm.agreementNo" placeholder="协议号" clearable />
						</div>
					</div>

					<div class="search-item">
						<label class="search-label">车牌号</label>
						<div class="search-control">
							<el-input v-model="searchForm.licensePlate" placeholder="车牌号" clearable />
						</div>
					</div>

					<div class="search-item">
						<label class="search-label">时间类型</label>
						<div class="search-control">
							<el-select v-model="searchForm.timeType" placeholder="请选择" clearable>
								<el-option label="签约时间" value="1" />
								<el-option label="签约回传时间" value="2" />
								<el-option label="解约回传时间" value="3" />
								<el-option label="协议起期" value="4" />
								<el-option label="协议止期" value="5" />
								<el-option label="解约时间" value="6" />
							</el-select>
						</div>
					</div>

					<div class="search-item">
						<label class="search-label">时间范围</label>
						<div class="search-control date-range-control">
							<el-date-picker v-model="searchForm.dateRange" type="daterange" range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp"
								:clearable="true" :disabled="!searchForm.timeType" />
						</div>
					</div>

					<div class="search-actions">
						<el-button class="search" type="primary" icon="el-icon-search" @click="handleSearch"
							:loading="loading">
							搜索
						</el-button>
						<el-button class="reset" icon="el-icon-refresh" @click="handleReset">重置</el-button>
					</div>
				</div>
			</div>
		</el-card>

		<!-- 数据表格区域 -->
		<div class="table-area">
			<div class="operation-left">
				<el-button type="primary" :disabled="selectedRows.length === 0" @click="handleBatchRetry"
					icon="el-icon-refresh-right">
					批量重试
				</el-button>
				<!-- 新增：批量退保按钮 -->
				<el-button type="warning" :disabled="selectedRows.length === 0" @click="handleBatchCancel"
					icon="el-icon-remove-outline" :loading="batchCancelLoading">
					批量退保
				</el-button>
				<el-button type="success" @click="handleDownload" icon="el-icon-download" :loading="exportLoading">
					下载
				</el-button>
				<!-- 新增字段显示控制按钮 -->
				<el-button type="info" @click="showColumnConfig" icon="el-icon-setting">
					字段显示
				</el-button>
				<span class="selection-tips" v-if="selectedRows.length > 0">
					已选择 {{ selectedRows.length }} 项
				</span>
			</div>

			<!-- 添加表格key，强制重新渲染 -->
			<el-table :key="tableKey" :data="tableData" style="width: 100%" v-loading="loading || tableRefreshing"
				element-loading-text="数据加载中..." element-loading-background="rgba(255, 255, 255, 0.7)"
				@selection-change="handleSelectionChange" size="small" height="calc(100vh - 420px)" ref="protocolTable"
				@header-dragend="handleHeaderDragEnd">
				<el-table-column type="selection" width="45" align="center" fixed="left" :key="'selection'" />
				<el-table-column v-if="columnConfig.id" prop="id" label="ID" width="60" align="center" fixed="left"
					:key="'id'" />
				<el-table-column v-if="columnConfig.orderNo" prop="orderNo" label="订单编号"
					:width="getColumnWidth('orderNo')" fixed="left" :key="'orderNo'" show-overflow-tooltip />
				<el-table-column v-if="columnConfig.calculatorSerialNo" prop="calculatorSerialNo" label="晶算师流水号"
					:width="getColumnWidth('calculatorSerialNo')" :key="'calculatorSerialNo'" show-overflow-tooltip />
				<el-table-column v-if="columnConfig.protocolSerialNo" prop="protocolSerialNo" label="协议流水号"
					:width="getColumnWidth('protocolSerialNo')" :key="'protocolSerialNo'" show-overflow-tooltip />
				<el-table-column v-if="columnConfig.protocolType" prop="protocolType" label="协议类型"
					:width="getColumnWidth('protocolType')" align="center" :key="'protocolType'" />
				<el-table-column v-if="columnConfig.productName" prop="productName" label="产品名称"
					:width="getColumnWidth('productName')" :key="'productName'" show-overflow-tooltip />
				<el-table-column v-if="columnConfig.productCode" prop="productCode" label="产品代码"
					:width="getColumnWidth('productCode')" align="center" :key="'productCode'" />
				<el-table-column v-if="columnConfig.schemeCode" prop="schemeCode" label="方案代码"
					:width="getColumnWidth('schemeCode')" align="center" :key="'schemeCode'" />
				<el-table-column v-if="columnConfig.schemeName" prop="schemeName" label="方案名称"
					:width="getColumnWidth('schemeName')" :key="'schemeName'" show-overflow-tooltip />
				<el-table-column v-if="columnConfig.licensePlate" prop="licensePlate" label="车牌号"
					:width="getColumnWidth('licensePlate')" align="center" :key="'licensePlate'" />
				<el-table-column v-if="columnConfig.protocolStatus" prop="protocolStatus" label="状态"
					:width="getColumnWidth('protocolStatus')" align="center" :key="'protocolStatus'">
					<template slot-scope="{ row }">
						<el-tag :type="getStatusType(row.protocolStatus)" size="small" effect="plain">
							{{ row.protocolStatus }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column v-if="columnConfig.fee" prop="fee" label="费用" :width="getColumnWidth('fee')"
					align="right" :key="'fee'">
					<template slot-scope="{ row }">
						<span class="fee-text">{{ row.fee ? formatCurrency(row.fee) : '-' }}</span>
					</template>
				</el-table-column>
				<el-table-column v-if="columnConfig.quota" prop="quota" label="额度" :width="getColumnWidth('quota')"
					align="right" :key="'quota'">
					<template slot-scope="{ row }">
						<span class="quota-text">{{ row.quota ? formatCurrency(row.quota) : '-' }}</span>
					</template>
				</el-table-column>
				<el-table-column v-if="columnConfig.signTime" prop="signTime" label="签约时间"
					:width="getColumnWidth('signTime')" align="center" :key="'signTime'">
					<template slot-scope="{ row }">
						{{ formatDateTime(row.signTime) }}
					</template>
				</el-table-column>
				<el-table-column v-if="columnConfig.signCallbackTime" prop="signCallbackTime" label="签约回传"
					:width="getColumnWidth('signCallbackTime')" align="center" :key="'signCallbackTime'">
					<template slot-scope="{ row }">
						{{ formatDateTime(row.signCallbackTime) }}
					</template>
				</el-table-column>
				<el-table-column v-if="columnConfig.protocolStartDate" prop="protocolStartDate" label="起期"
					:width="getColumnWidth('protocolStartDate')" align="center" :key="'protocolStartDate'">
					<template slot-scope="{ row }">
						{{ formatDateTime(row.protocolStartDate) }}
					</template>
				</el-table-column>
				<el-table-column v-if="columnConfig.protocolEndDate" prop="protocolEndDate" label="止期"
					:width="getColumnWidth('protocolEndDate')" align="center" :key="'protocolEndDate'">
					<template slot-scope="{ row }">
						{{ formatDateTime(row.protocolEndDate) }}
					</template>
				</el-table-column>
				<el-table-column v-if="columnConfig.cancelTime" prop="cancelTime" label="解约时间"
					:width="getColumnWidth('cancelTime')" align="center" :key="'cancelTime'">
					<template slot-scope="{ row }">
						{{ formatDateTime(row.cancelTime) }}
					</template>
				</el-table-column>
				<el-table-column v-if="columnConfig.cancelCallbackTime" prop="cancelCallbackTime" label="解约回传"
					:width="getColumnWidth('cancelCallbackTime')" align="center" :key="'cancelCallbackTime'">
					<template slot-scope="{ row }">
						{{ formatDateTime(row.cancelCallbackTime) }}
					</template>
				</el-table-column>
				<el-table-column label="操作" min-width="120" align="center" fixed="right" :key="'operation'">
					<template slot-scope="{ row }">
						<div class="operation-buttons">
							<el-button type="text" size="small" @click="handleView(row)">查看</el-button>
							<!-- 新增：单个退保按钮 -->
							<el-button
								type="text" 
								size="small" 
								@click="handleSingleCancel(row)"
								:disabled="!canCancel(row)"
								:loading="row.cancelLoading"
								style="color: #E6A23C; margin-left: 8px;"
							>
								退保
							</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<!-- 分页 -->
			<div class="pagination-area">
				<el-pagination v-model:current-page="pagination.currentPage" v-model:page-size="pagination.pageSize"
					:page-sizes="[10, 20, 50, 100]" :total="pagination.total"
					layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" size="small" :disabled="loading || tableRefreshing" />
			</div>
		</div>

		<!-- 查看详情对话框 -->
		<el-dialog :visible.sync="dialogVisible" title="协议详情" width="800px" append-to-body>
			<el-descriptions :column="2" border size="medium">
				<el-descriptions-item label="ID">{{ currentRow.id }}</el-descriptions-item>
				<el-descriptions-item label="订单编号">{{ currentRow.orderNo }}</el-descriptions-item>
				<el-descriptions-item label="投标企业">{{ currentRow.bidCompany }}</el-descriptions-item>
				<el-descriptions-item label="晶算师流水号">{{ currentRow.calculatorSerialNo }}</el-descriptions-item>
				<el-descriptions-item label="协议流水号">{{ currentRow.protocolSerialNo }}</el-descriptions-item>
				<el-descriptions-item label="协议类型">{{ currentRow.protocolType }}</el-descriptions-item>
				<el-descriptions-item label="产品名称">{{ currentRow.productName }}</el-descriptions-item>
				<el-descriptions-item label="产品代码">{{ currentRow.productCode }}</el-descriptions-item>
				<el-descriptions-item label="方案代码">{{ currentRow.schemeCode }}</el-descriptions-item>
				<el-descriptions-item label="方案名称">{{ currentRow.schemeName }}</el-descriptions-item>
				<el-descriptions-item label="车牌号">{{ currentRow.licensePlate }}</el-descriptions-item>
				<el-descriptions-item label="协议状态">
					<el-tag :type="getStatusType(currentRow.protocolStatus)" size="small">
						{{ currentRow.protocolStatus }}
					</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="费用">
					{{ currentRow.fee ? formatCurrency(currentRow.fee) : '-' }}
				</el-descriptions-item>
				<el-descriptions-item label="额度">
					{{ currentRow.quota ? formatCurrency(currentRow.quota) : '-' }}
				</el-descriptions-item>
				<el-descriptions-item label="签约时间">{{ formatDateTime(currentRow.signTime) }}</el-descriptions-item>
				<el-descriptions-item
					label="签约回传时间">{{ formatDateTime(currentRow.signCallbackTime) }}</el-descriptions-item>
				<el-descriptions-item
					label="协议起期">{{ formatDateTime(currentRow.protocolStartDate) }}</el-descriptions-item>
				<el-descriptions-item
					label="协议止期">{{ formatDateTime(currentRow.protocolEndDate) }}</el-descriptions-item>
				<el-descriptions-item label="解约时间">{{ formatDateTime(currentRow.cancelTime) }}</el-descriptions-item>
				<el-descriptions-item
					label="解约回传时间">{{ formatDateTime(currentRow.cancelCallbackTime) }}</el-descriptions-item>
			</el-descriptions>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">关闭</el-button>
			</span>
		</el-dialog>

		<!-- 字段显示控制对话框 -->
		<el-dialog :visible.sync="columnDialogVisible" title="字段显示控制" width="500px" append-to-body
			@close="handleColumnDialogClose">
			<div class="column-config-container">
				<div class="column-config-header">
					<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
						全选/全不选
					</el-checkbox>
					<el-button type="text" size="small" @click="resetToDefault">
						恢复默认
					</el-button>
				</div>

				<el-divider></el-divider>

				<div class="column-list">
					<el-checkbox-group v-model="checkedColumns" @change="handleCheckedColumnsChange">
						<div class="column-group">
							<h4>基本信息</h4>
							<el-checkbox label="id">ID</el-checkbox>
							<el-checkbox label="orderNo">订单编号</el-checkbox>
							<el-checkbox label="calculatorSerialNo">晶算师流水号</el-checkbox>
							<el-checkbox label="protocolSerialNo">协议流水号</el-checkbox>
						</div>

						<div class="column-group">
							<h4>协议信息</h4>
							<el-checkbox label="protocolType">协议类型</el-checkbox>
							<el-checkbox label="protocolStatus">状态</el-checkbox>
						</div>

						<div class="column-group">
							<h4>产品信息</h4>
							<el-checkbox label="productName">产品名称</el-checkbox>
							<el-checkbox label="productCode">产品代码</el-checkbox>
							<el-checkbox label="schemeCode">方案代码</el-checkbox>
							<el-checkbox label="schemeName">方案名称</el-checkbox>
						</div>

						<div class="column-group">
							<h4>车辆信息</h4>
							<el-checkbox label="licensePlate">车牌号</el-checkbox>
						</div>

						<div class="column-group">
							<h4>费用信息</h4>
							<el-checkbox label="fee">费用</el-checkbox>
							<el-checkbox label="quota">额度</el-checkbox>
						</div>

						<div class="column-group">
							<h4>时间信息</h4>
							<el-checkbox label="signTime">签约时间</el-checkbox>
							<el-checkbox label="signCallbackTime">签约回传</el-checkbox>
							<el-checkbox label="protocolStartDate">起期</el-checkbox>
							<el-checkbox label="protocolEndDate">止期</el-checkbox>
							<el-checkbox label="cancelTime">解约时间</el-checkbox>
							<el-checkbox label="cancelCallbackTime">解约回传</el-checkbox>
						</div>
					</el-checkbox-group>
				</div>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="columnDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="saveColumnConfig" :loading="tableRefreshing">确认</el-button>
			</span>
		</el-dialog>

		<!-- 下载文件生成对话框 -->
		<el-dialog :visible.sync="downloadDialogVisible" title="文件生成" width="500px" append-to-body>
			<div class="download-dialog-content">
				<div v-if="downloadInfo.status === 'processing'" class="processing-status">
					<el-icon class="loading-icon" size="40">
						<i class="el-icon-loading"></i>
					</el-icon>
					<p>{{ downloadInfo.message }}</p>
				</div>
				
				<div v-else-if="downloadInfo.status === 'success'" class="success-status">
					<el-icon class="success-icon" size="40" color="#67C23A">
						<i class="el-icon-circle-check"></i>
					</el-icon>
					<p>{{ downloadInfo.message }}</p>
					
					<div v-if="downloadInfo.fileId" class="file-info">
						<p><strong>文件ID：</strong>{{ downloadInfo.fileId }}</p>
					</div>
					<div v-if="downloadInfo.taskId" class="file-info">
						<p><strong>任务ID：</strong>{{ downloadInfo.taskId }}</p>
					</div>
				</div>
				
				<div v-else class="error-status">
					<el-icon class="error-icon" size="40" color="#F56C6C">
						<i class="el-icon-circle-close"></i>
					</el-icon>
					<p>{{ downloadInfo.message }}</p>
				</div>
			</div>
			
			<span slot="footer" class="dialog-footer">
				<el-button @click="downloadDialogVisible = false">关闭</el-button>
				<el-button 
					v-if="downloadInfo.status === 'success'" 
					type="primary" 
					@click="goToDownloadCenter"
				>
					前往下载中心
				</el-button>
				<el-button 
					v-if="downloadInfo.status === 'error'" 
					type="primary" 
					@click="retryDownload"
					:loading="exportLoading"
				>
					重试
				</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'ProtocolList',
		data() {
			// 默认列配置
			const defaultColumnConfig = {
				id: true,
				orderNo: true,
				calculatorSerialNo: true,
				protocolSerialNo: true,
				protocolType: true,
				productName: true,
				productCode: true,
				schemeCode: true,
				schemeName: true,
				licensePlate: true,
				protocolStatus: true,
				fee: true,
				quota: true,
				signTime: true,
				signCallbackTime: true,
				protocolStartDate: true,
				protocolEndDate: true,
				cancelTime: true,
				cancelCallbackTime: true
			};

			// 列宽度配置
			const columnWidths = {
				id: 60,
				orderNo: 90,
				calculatorSerialNo: 120,
				protocolSerialNo: 110,
				protocolType: 80,
				productName: 110,
				productCode: 80,
				schemeCode: 80,
				schemeName: 110,
				licensePlate: 85,
				protocolStatus: 70,
				fee: 80,
				quota: 100,
				signTime: 120,
				signCallbackTime: 120,
				protocolStartDate: 100,
				protocolEndDate: 100,
				cancelTime: 120,
				cancelCallbackTime: 120
			};

			return {
				// 搜索表单数据
				searchForm: {
					bidCompany: '',
					protocolType: '',
					protocolStatus: '',
					programName: '',
					orderNo: '',
					agreementNo: '',
					licensePlate: '',
					timeType: '',
					dateRange: []
				},

				// 表格数据
				tableData: [],

				// 分页数据
				pagination: {
					currentPage: 1,
					pageSize: 10,
					total: 0
				},

				// 加载状态
				loading: false,
				exportLoading: false,
				batchCancelLoading: false, // 新增：批量退保加载状态
				tableRefreshing: false, // 新增：表格刷新状态

				// 选中的数据
				selectedRows: [],

				// 对话框相关
				dialogVisible: false,
				currentRow: {},

				// 字段显示控制相关
				columnDialogVisible: false,
				columnConfig: JSON.parse(JSON.stringify(defaultColumnConfig)), // 深拷贝默认配置
				defaultColumnConfig: defaultColumnConfig,
				columnWidths: columnWidths,
				checkedColumns: [],
				checkAll: true,
				isIndeterminate: false,

				// 表格重新渲染的key
				tableKey: 0,

				// 保存用户调整后的列宽
				customColumnWidths: {},

				// 临时列配置（用于对话框中的修改）
				tempColumnConfig: null,

				// 下载相关
				downloadDialogVisible: false,
				downloadInfo: {
					fileId: '',
					taskId: '',
					status: '', // processing, success, error
					message: ''
				}
			}
		},
		methods: {
			// 添加一个通用的调用方法
			async callUpdateProtocolStatus(ids) {
				// 使用axios的params序列化功能
				return await this.$etcPost('order-protocol-info-do/update-protocol-status-by-ids', null, {
					params: {
						ids: ids  // axios会自动将数组转换为 ids=1&ids=2&ids=3 格式
					},
					paramsSerializer: function(params) {
						// 如果需要自定义参数序列化
						return Object.keys(params)
							.map(key => {
								if (Array.isArray(params[key])) {
									return params[key].map(val => `${key}=${encodeURIComponent(val)}`).join('&');
								}
								return `${key}=${encodeURIComponent(params[key])}`;
							})
							.join('&');
					}
				});
			},
			// 初始化搜索表单
			initSearchForm() {
				return {
					bidCompany: '',
					protocolType: '',
					protocolStatus: '',
					programName: '',
					orderNo: '',
					agreementNo: '',
					licensePlate: '',
					timeType: '',
					dateRange: []
				}
			},

			// 构建查询参数
			buildQueryParams() {
				const params = {
					pageIndex: this.pagination.currentPage,
					pageSize: this.pagination.pageSize
				};

				// 投标企业
				if (this.searchForm && this.searchForm.bidCompany) {
					params.bidCompany = this.searchForm.bidCompany;
				}

				// 协议类型
				if (this.searchForm && this.searchForm.protocolType) {
					params.protocolType = this.searchForm.protocolType;
				}

				// 协议状态
				if (this.searchForm && this.searchForm.protocolStatus) {
					params.protocolStatus = this.searchForm.protocolStatus;
				}

				// 方案名称
				if (this.searchForm && this.searchForm.programName) {
					params.programName = this.searchForm.programName;
				}

				// 订单编号
				if (this.searchForm && this.searchForm.orderNo) {
					params.orderNo = this.searchForm.orderNo;
				}

				// 协议号
				if (this.searchForm && this.searchForm.agreementNo) {
					params.agreementNo = this.searchForm.agreementNo;
				}

				// 车牌号
				if (this.searchForm && this.searchForm.licensePlate) {
					params.licensePlate = this.searchForm.licensePlate;
				}

				// 时间类型
				if (this.searchForm && this.searchForm.timeType) {
					params.timeType = this.searchForm.timeType;
				}

				// 处理时间范围
				if (this.searchForm &&
					this.searchForm.dateRange &&
					Array.isArray(this.searchForm.dateRange) &&
					this.searchForm.dateRange.length === 2) {
					params.beginTime = this.searchForm.dateRange[0];
					params.endTime = this.searchForm.dateRange[1];
				}

				return params;
			},

			// 搜索
			async handleSearch() {
				this.pagination.currentPage = 1;
				await this.fetchTableData();
			},

			// 重置搜索
			handleReset() {
				// 使用深拷贝重置搜索表单
				this.searchForm = this.initSearchForm();
				this.handleSearch();
			},

			// 获取表格数据
			async fetchTableData() {
				this.loading = true;

				try {
					// 构建查询参数
					const params = this.buildQueryParams();

					// 调用后端接口 - 使用项目的封装方法
					const res = await this.$etcGet('order-protocol-info-do/get-file-info-page', params);

					if (res && res.code === 0 && res.result) {
						this.processTableData(res.result);
					} else {
						this.resetTableData();
					}
				} catch (error) {
					this.handleFetchError(error);
				} finally {
					this.loading = false;
				}
			},

			// 处理表格数据
			processTableData(result) {
				const dataList = result.list || result.records || [];
				// 为每条数据添加 cancelLoading 属性
				this.tableData = dataList.map(item => ({
					...item,
					cancelLoading: false
				}));
				this.pagination.total = result.total || result.totalCount || 0;
			},

			// 重置表格数据
			resetTableData() {
				this.tableData = [];
				this.pagination.total = 0;
				this.$message.warning('未查询到数据');
			},

			// 处理获取数据错误
			handleFetchError(error) {
				console.error('获取协议列表失败:', error);
				const errorMessage = error.message || '获取协议列表失败';
				this.$notify.error({
					title: '数据获取失败',
					message: errorMessage
				});
			},

			// 批量重试
			async handleBatchRetry() {
				if (this.selectedRows.length === 0) {
					this.$message.warning('请至少选择一条数据');
					return;
				}

				try {
					await this.$confirm(
						`确定要对选中的 ${this.selectedRows.length} 条协议进行批量重试操作吗？`,
						'确认操作', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}
					);

					// 获取选中项的ID
					const ids = this.selectedRows.map(row => row.id);

					// 调用批量重试接口
					const res = await this.$etcPost('order-protocol-info-do/batch-retry', {
						ids
					});

					if (res && res.code === 0) {
						this.$message.success('批量重试操作成功');
						this.selectedRows = [];
						await this.fetchTableData();
					} else {
						this.$message.error(res.message || '操作失败');
					}
				} catch (error) {
					if (error !== 'cancel') {
						this.$message.error('操作失败');
					}
				}
			},

			// 新增：批量退保
			async handleBatchCancel() {
				if (this.selectedRows.length === 0) {
					this.$message.warning('请至少选择一条数据');
					return;
				}

				// 检查选中的协议是否可以退保
				const invalidRows = this.selectedRows.filter(row => !this.canCancel(row));
				if (invalidRows.length > 0) {
					const invalidProtocols = invalidRows.map(row => row.protocolSerialNo || row.orderNo).join('、');
					this.$message.warning(`以下协议无法退保：${invalidProtocols}`);
					return;
				}

				try {
					await this.$confirm(
						`确定要对选中的 ${this.selectedRows.length} 条协议进行批量退保操作吗？`,
						'批量退保确认', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning',
							beforeClose: async (action, instance, done) => {
								if (action === 'confirm') {
									instance.confirmButtonLoading = true;
									try {
										await this.executeBatchCancel();
										done();
									} catch (err) {
										console.error(err);
										instance.confirmButtonLoading = false;
									}
								} else {
									done();
								}
							}
						}
					).then(() => {
						// 成功后清空选择
						this.selectedRows = [];
					}).catch(() => {
						// 取消操作
					});
				} catch (error) {
					// 用户取消操作
				}
			},

			// 执行批量退保
			async executeBatchCancel() {
				try {
					this.batchCancelLoading = true;
					
					const ids = this.selectedRows.map(row => row.id);
					
					if (ids.length === 0) {
						this.$message.warning('请选择要退保的协议');
						return;
					}
					
					console.log('调用接口，参数:', ids);
					
					const res = await this.callUpdateProtocolStatus(ids);
					
					if (res && res.code === 0) {
						this.$message.success(`批量退保成功，共处理 ${ids.length} 条协议`);
						this.selectedRows = [];
						await this.fetchTableData();
					} else {
						this.$message.error(res.message || '批量退保失败');
					}
				} catch (error) {
					console.error('批量退保失败:', error);
					this.$message.error('批量退保失败，请稍后重试');
				} finally {
					this.batchCancelLoading = false;
				}
			},

			// 新增：单个退保
			async handleSingleCancel(row) {
				if (!this.canCancel(row)) {
					this.$message.warning('当前协议无法退保');
					return;
				}
			
				try {
					await this.$confirm(
						`确定要对协议 ${row.protocolSerialNo || row.orderNo} 执行退保操作吗？`,
						'退保确认', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}
					).then(async () => {
						this.$set(row, 'cancelLoading', true);

						try {
							const res = await this.callUpdateProtocolStatus([row.id]);
							
							if (res && res.code === 0) {
								this.$message.success('退保成功');
								await this.fetchTableData();
							} else {
								this.$message.error(res.message || '退保失败');
							}
						} catch (error) {
							console.error('退保失败:', error);
							this.$message.error('退保失败，请稍后重试');
						} finally {
							this.$set(row, 'cancelLoading', false);
						}
					}).catch(() => {
						// 取消操作
					});
				} catch (error) {
					// 用户取消操作
				}
			},

			// 新增：检查协议是否可以退保
			canCancel(row) {
				// 根据业务逻辑判断哪些状态可以退保
				// 例如：只有"已签约"状态的协议可以退保
				const canCancelStatus = ['已签约']; // 可以根据需要调整
				return canCancelStatus.includes(row.protocolStatus);
			},

			// 下载Excel
			async handleDownload() {
				this.exportLoading = true;
				try {
					// 构建查询参数
					const params = this.buildQueryParams();

					// 导出时不需要分页参数
					delete params.pageIndex;
					delete params.pageSize;

					// 显示下载对话框
					this.downloadDialogVisible = true;
					this.downloadInfo = {
						fileId: '',
						taskId: '',
						status: 'processing',
						message: '正在生成文件，请稍候...'
					};

					// 调用生成Excel文件接口（POST请求）
					const res = await this.$etcPost('file-info-do/create', params);

					if (res && res.code === 0) {
						const result = res.result || res.data;
						
						if (result && result.fileId) {
							// 情况1：返回文件ID
							this.downloadInfo = {
								fileId: result.fileId,
								taskId: result.taskId || '',
								status: 'success',
								message: '文件已生成成功！'
							};
						} else if (result && result.taskId) {
							// 情况2：返回任务ID
							this.downloadInfo = {
								fileId: result.fileId || '',
								taskId: result.taskId,
								status: 'success',
								message: '文件生成任务已提交！'
							};
						} else {
							// 情况3：接口返回其他格式
							this.downloadInfo = {
								status: 'success',
								message: '文件生成任务已提交！'
							};
						}
					} else {
						this.downloadInfo = {
							status: 'error',
							message: res.message || '文件生成失败'
						};
					}
				} catch (error) {
					console.error('生成文件失败:', error);
					this.downloadInfo = {
						status: 'error',
						message: error.message || '文件生成失败，请重试'
					};
				} finally {
					this.exportLoading = false;
				}
			},

			// 重试下载
			async retryDownload() {
				this.downloadDialogVisible = false;
				await this.handleDownload();
			},

			// 前往下载中心
			goToDownloadCenter() {
				this.downloadDialogVisible = false;
				// 跳转到下载中心页面
				// this.$router.push('/download-center');
				
				// 如果下载中心页面有特定路由，可以这样跳转
				// 如果没有，可以显示提示信息
				this.$message.info('请到系统菜单中的"下载中心"查看和下载文件');
			},

			// 查看详情
			handleView(row) {
				this.currentRow = {
					...row
				};
				this.dialogVisible = true;
			},

			// 表格选择变化
			handleSelectionChange(selection) {
				this.selectedRows = selection;
			},

			// 分页大小变化
			handleSizeChange(size) {
				this.pagination.pageSize = size;
				this.fetchTableData();
			},

			// 当前页变化
			handleCurrentChange(page) {
				this.pagination.currentPage = page;
				this.fetchTableData();
			},

			// 获取状态标签类型
			getStatusType(status) {
				if (!status) return 'info';

				const typeMap = {
					'待签约': 'warning',
					'已签约': 'success',
					'签约失败': 'danger',
					'已解约': 'info'
				};
				return typeMap[status] || 'info';
			},

			// 格式化货币金额
			formatCurrency(value) {
				if (value === null || value === undefined || value === '') return '-';
				try {
					const num = Number(value);
					if (isNaN(num)) return '-';
					return `¥${num.toLocaleString('zh-CN', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				})}`;
				} catch {
					return '-';
				}
			},

			// 格式化日期时间
			formatDateTime(dateTime) {
				if (!dateTime) return '-';
				try {
					// 如果已经是格式化好的字符串，直接返回
					if (typeof dateTime === 'string') {
						// 尝试解析和重新格式化
						const date = new Date(dateTime);
						if (isNaN(date.getTime())) {
							return dateTime; // 如果不是有效日期，返回原字符串
						}
						// 格式化日期时间
						const year = date.getFullYear();
						const month = String(date.getMonth() + 1).padStart(2, '0');
						const day = String(date.getDate()).padStart(2, '0');
						const hours = String(date.getHours()).padStart(2, '0');
						const minutes = String(date.getMinutes()).padStart(2, '0');
						const seconds = String(date.getSeconds()).padStart(2, '0');

						return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
					}
					// 如果是时间戳
					if (typeof dateTime === 'number') {
						const date = new Date(dateTime);
						if (isNaN(date.getTime())) return '-';

						const year = date.getFullYear();
						const month = String(date.getMonth() + 1).padStart(2, '0');
						const day = String(date.getDate()).padStart(2, '0');
						const hours = String(date.getHours()).padStart(2, '0');
						const minutes = String(date.getMinutes()).padStart(2, '0');
						const seconds = String(date.getSeconds()).padStart(2, '0');

						return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
					}
					return '-';
				} catch (error) {
					console.error('格式化日期时间错误:', error);
					return '-';
				}
			},

			// ========== 字段显示控制相关方法 ==========

			// 显示字段配置对话框
			showColumnConfig() {
				// 保存当前配置到临时变量
				this.tempColumnConfig = JSON.parse(JSON.stringify(this.columnConfig));

				// 根据当前列配置更新选中状态
				this.updateCheckedColumns();
				this.columnDialogVisible = true;
			},

			// 更新选中列的数组
			updateCheckedColumns() {
				this.checkedColumns = Object.keys(this.columnConfig)
					.filter(key => this.columnConfig[key] === true);

				// 更新全选状态
				const totalColumns = Object.keys(this.columnConfig).length;
				const checkedCount = this.checkedColumns.length;
				this.checkAll = checkedCount === totalColumns;
				this.isIndeterminate = checkedCount > 0 && checkedCount < totalColumns;
			},

			// 处理全选/全不选
			handleCheckAllChange(val) {
				const allColumns = Object.keys(this.tempColumnConfig);

				if (val) {
					// 全选
					this.checkedColumns = [...allColumns];
					allColumns.forEach(key => {
						this.tempColumnConfig[key] = true;
					});
				} else {
					// 全不选（但至少要保留一个）
					if (this.checkedColumns.length === 1) {
						this.$message.warning('至少需要显示一个字段');
						return;
					}
					this.checkedColumns = [];
					allColumns.forEach(key => {
						this.tempColumnConfig[key] = false;
					});
				}
				this.isIndeterminate = false;
			},

			// 处理列选择变化
			handleCheckedColumnsChange(value) {
				const totalColumns = Object.keys(this.tempColumnConfig).length;
				const checkedCount = value.length;

				// 确保至少有一个字段被选中
				if (checkedCount === 0) {
					this.$message.warning('至少需要显示一个字段');
					// 恢复上一个选中状态
					this.checkedColumns = [...this.checkedColumns];
					return;
				}

				this.checkAll = checkedCount === totalColumns;
				this.isIndeterminate = checkedCount > 0 && checkedCount < totalColumns;

				// 更新临时列配置
				Object.keys(this.tempColumnConfig).forEach(key => {
					this.tempColumnConfig[key] = value.includes(key);
				});
			},

			// 恢复默认配置
			resetToDefault() {
				this.tempColumnConfig = JSON.parse(JSON.stringify(this.defaultColumnConfig));
				this.updateCheckedColumns();
				this.$message.success('已恢复默认字段设置');
			},

			// 保存列配置
			async saveColumnConfig() {
				this.tableRefreshing = true;

				try {
					// 检查配置是否有变化
					const hasChanged = JSON.stringify(this.columnConfig) !== JSON.stringify(this.tempColumnConfig);

					if (!hasChanged) {
						this.columnDialogVisible = false;
						return;
					}

					// 更新列配置
					this.columnConfig = JSON.parse(JSON.stringify(this.tempColumnConfig));

					// 这里可以添加保存到本地存储或后端的逻辑
					// localStorage.setItem('protocol_list_column_config', JSON.stringify(this.columnConfig));

					// 重置选中行（因为表格会重新渲染）
					this.selectedRows = [];

					// 给表格一个微小的延迟，确保DOM更新
					await this.$nextTick();

					// 强制表格重新渲染
					this.refreshTable();

					// 关闭对话框
					this.columnDialogVisible = false;

					this.$message.success('字段显示设置已保存');
				} catch (error) {
					console.error('保存列配置失败:', error);
					this.$message.error('保存失败');
				} finally {
					this.tableRefreshing = false;
				}
			},

			// 处理列配置对话框关闭
			handleColumnDialogClose() {
				// 恢复之前的配置
				this.tempColumnConfig = null;
			},

			// 获取列宽度（优先使用用户调整的宽度）
			getColumnWidth(columnName) {
				// 优先使用用户自定义的宽度
				if (this.customColumnWidths[columnName]) {
					return this.customColumnWidths[columnName];
				}
				// 使用默认宽度
				return this.columnWidths[columnName] || 100;
			},

			// 处理表头拖拽结束
			handleHeaderDragEnd(newWidth, oldWidth, column, event) {
				if (column && column.property) {
					// 保存用户调整的列宽
					this.customColumnWidths[column.property] = newWidth;
				}
			},

			// 刷新表格（强制重新渲染）
			refreshTable() {
				this.tableKey += 1;

				// 如果有表格实例，可以调用其doLayout方法
				if (this.$refs.protocolTable) {
					this.$nextTick(() => {
						this.$refs.protocolTable.doLayout();
					});
				}
			},

			// 加载保存的列配置（可选）
			loadSavedColumnConfig() {
				try {
					// const savedConfig = localStorage.getItem('protocol_list_column_config');
					// if (savedConfig) {
					// 	const parsedConfig = JSON.parse(savedConfig);
					// 	// 确保配置包含所有字段
					// 	Object.keys(this.defaultColumnConfig).forEach(key => {
					// 		if (parsedConfig[key] !== undefined) {
					// 			this.columnConfig[key] = parsedConfig[key];
					// 		}
					// 	});
					// 	this.refreshTable();
					// }
				} catch (error) {
					console.error('加载列配置失败:', error);
				}
			}
		},
		watch: {
			// 监听时间类型变化，清空时间范围
			'searchForm.timeType'(newVal) {
				if (!newVal && this.searchForm) {
					this.searchForm.dateRange = [];
				}
			},

			// 监听列配置变化，自动刷新表格
			columnConfig: {
				handler() {
					// 延迟刷新，确保DOM更新完成
					setTimeout(() => {
						if (this.$refs.protocolTable) {
							this.$refs.protocolTable.doLayout();
						}
					}, 50);
				},
				deep: true
			}
		},
		mounted() {
			// 确保 searchForm 已初始化
			if (!this.searchForm) {
				this.searchForm = this.initSearchForm();
			}

			// 加载保存的列配置（可选）
			// this.loadSavedColumnConfig();

			// 初始化选中列
			this.updateCheckedColumns();

			this.fetchTableData();
		}
	}
</script>

<style scoped lang="scss">
	.protocol-list-container {
		padding: 20px;
		background-color: #f5f7fa;
		height: 100%;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}

	.search-card {
		margin-bottom: 16px;
		border-radius: 10px;

		// 修复深度选择器
		::v-deep .el-card__body {
			padding: 24px 20px !important;
		}
	}

	.page-title {
		margin-bottom: 20px;
		font-size: 20px;
		color: #3b3c3f;
	}

	.search-form {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.search-row {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: 12px;

		// 第二行特殊样式
		&:last-child {
			.search-item {
				flex: 0 1 auto;
				max-width: 280px;
			}
		}
	}

	.search-item {
		display: flex;
		align-items: center;
		flex: 1;
		min-width: 280px;
		max-width: 280px;
	}

	.search-label {
		width: 70px;
		flex-shrink: 0;
		text-align: left;
		padding-right: 8px;
		font-size: 14px;
		color: #707070;
		line-height: 32px;
	}

	.search-control {
		flex: 1;
		min-width: 0;

		::v-deep .el-select,
		::v-deep .el-input {
			width: calc(100% - 20px);

			.el-input__inner {
				height: 32px;
				line-height: 32px;
				font-size: 14px;
			}
		}

		.date-range-control {
			::v-deep .el-date-picker {
				width: calc(100% - 20px);

				.el-range-editor {
					height: 32px;
					padding: 0 8px;
					width: 100%;

					.el-range-input {
						font-size: 13px;
						width: 45%;
					}

					.el-range-separator {
						line-height: 24px;
						font-size: 12px;
						padding: 0 4px;
					}
				}
			}
		}
	}

	.search-actions {
		display: flex;
		align-items: center;
		gap: 8px;
		height: 32px;
		flex-shrink: 0;
		margin-left: auto;

		.el-button {
			border-radius: 5px;
			width: 70px;
		}

		.search {
			background-color: #2280fd;
			border-color: #2280fd;
		}

		.reset {
			background-color: #fff;
			border-color: #e7e7e7;
		}
	}

	.operation-left {
		display: flex;
		align-items: center;
		gap: 12px;
		margin-bottom: 20px;
		padding: 0;

		.el-button {
			border-radius: 5px;
		}

		.el-button--primary {
			background-color: #2280fd;
			border-color: #2280fd;
		}
		
		// 新增：批量退保按钮样式
		.el-button--warning {
			background-color: #e6a23c;
			border-color: #e6a23c;
		}

		.el-button--success {
			background-color: #67c23a;
			border-color: #67c23a;
		}

		// 字段显示按钮特殊样式
		.el-button--info {
			background-color: #909399;
			border-color: #909399;
		}
		
		// 禁用状态
		.el-button.is-disabled {
			opacity: 0.6;
			cursor: not-allowed;
		}
	}

	.selection-tips {
		font-size: 13px;
		color: #409eff;
		background: #ecf5ff;
		padding: 4px 10px;
		border-radius: 3px;
		margin-left: 8px;
	}

	.table-area {
		flex: 1;
		display: flex;
		flex-direction: column;
		background: #fff;
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
		padding: 20px;

		.operation-left {
			flex-shrink: 0;
			margin-bottom: 20px;
			padding: 0;
		}

		::v-deep .el-table {
			flex: 1;
			min-height: 0;
			border-bottom: 1px solid #ebeef5;

			.el-table__body-wrapper {
				overflow-y: auto;
			}

			// 确保列宽正常
			.el-table__header-wrapper,
			.el-table__body-wrapper {
				width: 100% !important;
			}

			// 修复固定列的样式
			.el-table__fixed,
			.el-table__fixed-right {
				height: 100% !important;
			}
			
			// 操作按钮容器
			.operation-buttons {
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}

		.pagination-area {
			flex-shrink: 0;
			background: #fff;
			border-radius: 6px;
			padding: 12px 16px;
			margin-top: 16px;
			display: flex;
			justify-content: flex-end;
		}
	}

	.fee-text {
		color: #e6a23c;
		font-weight: 500;
		font-size: 12px;
	}

	.quota-text {
		color: #409eff;
		font-weight: 500;
		font-size: 12px;
	}

	// 字段显示控制对话框样式
	.column-config-container {
		.column-config-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 10px;

			.el-button {
				padding: 0;
			}
		}

		.column-list {
			max-height: 400px;
			overflow-y: auto;
			padding-right: 10px;

			.column-group {
				margin-bottom: 20px;

				&:last-child {
					margin-bottom: 0;
				}

				h4 {
					margin: 0 0 10px 0;
					font-size: 14px;
					color: #333;
					font-weight: 600;
				}

				.el-checkbox {
					display: block;
					margin-bottom: 8px;
					margin-left: 0;

					&:last-child {
						margin-bottom: 0;
					}
				}
			}
		}
	}

	// 下载对话框样式
	.download-dialog-content {
		text-align: center;
		padding: 30px 20px;
		
		.processing-status,
		.success-status,
		.error-status {
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: 20px;
			
			p {
				margin: 0;
				font-size: 16px;
				line-height: 1.5;
				color: #606266;
			}
		}
		
		.file-info {
			margin-top: 15px;
			padding: 12px;
			background-color: #f5f7fa;
			border-radius: 6px;
			text-align: left;
			width: 100%;
			max-width: 400px;
			
			p {
				margin: 5px 0;
				font-size: 14px;
				
				strong {
					color: #303133;
				}
			}
		}
		
		.loading-icon {
			animation: rotating 2s linear infinite;
		}
		
		.success-icon,
		.error-icon {
			svg {
				width: 40px;
				height: 40px;
			}
		}
	}

	// 表格加载动画
	.table-loading {
		position: relative;
		min-height: 200px;

		.loading-overlay {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background: rgba(255, 255, 255, 0.9);
			display: flex;
			align-items: center;
			justify-content: center;
			z-index: 10;
		}
	}

	::v-deep .el-table {
		font-size: 14px;

		&.el-table--small {
			.el-table__header {
				th {
					padding: 6px 0;
					background-color: #f8fafc;
					color: #707070;
					height: 36px;
				}
			}

			.el-table__body {
				td {
					padding: 4px 0;
					height: 36px;
				}

				tr:hover>td {
					background-color: #f5f7fa !important;
				}
			}

			.el-checkbox {
				transform: scale(0.85);
			}
		}

		.el-tag {
			font-size: 11px;
			height: 22px;
			line-height: 20px;
			padding: 0 6px;
		}

		// 确保列宽度正常
		.cell {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}

	// 旋转动画
	@keyframes rotating {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}

	// 响应式调整
	@media (max-width: 1600px) {
		.search-item {
			min-width: 150px;
			max-width: 180px;
		}

		.search-row:last-child {
			.search-item {
				max-width: 160px;
			}
		}
	}

	@media (max-width: 1440px) {
		.search-item {
			min-width: 140px;
			max-width: 160px;
		}

		.search-row:last-child {
			.search-item {
				max-width: 150px;
			}
		}

		.search-label {
			width: 65px;
			padding-right: 6px;
			font-size: 13px;
		}

		.search-control {
			::v-deep .el-select,
			::v-deep .el-input {
				width: calc(100% - 15px);
			}

			.date-range-control {
				::v-deep .el-date-picker {
					width: calc(100% - 15px);

					.el-range-editor {
						.el-range-input {
							font-size: 12px;
							max-width: 60px;
						}

						.el-range-separator {
							font-size: 11px;
							padding: 0 3px;
						}
					}
				}
			}
		}
	}

	@media (max-width: 1200px) {
		.search-form {
			gap: 8px;
		}

		.search-row {
			gap: 8px;

			&:last-child {
				flex-wrap: nowrap;
				overflow-x: auto;
			}
		}

		.search-item {
			min-width: calc(20% - 8px);
			max-width: calc(20% - 8px);
			flex-shrink: 1;
		}

		.search-actions {
			margin-left: 0;
			flex-shrink: 0;

			::v-deep .el-button {
				white-space: nowrap;
			}
		}

		.search-control {
			::v-deep .el-select,
			::v-deep .el-input {
				width: calc(100% - 10px);
			}

			.date-range-control {
				::v-deep .el-date-picker {
					width: calc(100% - 10px);

					.el-range-editor {
						.el-range-input {
							width: 40%;
						}
					}
				}
			}
		}
	}

	@media (max-width: 992px) {
		.search-item {
			min-width: calc(33.333% - 8px);
			max-width: calc(33.333% - 8px);
		}

		.search-row:last-child {
			flex-wrap: wrap;

			.search-actions {
				width: 100%;
				margin-top: 8px;
				justify-content: flex-start;
			}
		}
	}

	@media (max-width: 768px) {
		.search-item {
			min-width: 100%;
			max-width: 100%;
		}

		.search-actions {
			justify-content: center;

			::v-deep .el-button {
				width: 100px;
			}
		}

		.column-config-container {
			.column-list {
				max-height: 300px;
			}
		}
		
		.operation-left {
			flex-wrap: wrap;
			gap: 8px;
			
			.el-button {
				flex: 1;
				min-width: calc(50% - 8px);
			}
			
			.selection-tips {
				width: 100%;
				margin-top: 8px;
				margin-left: 0;
				text-align: center;
			}
		}
		
		.download-dialog-content {
			padding: 20px 10px;
			
			.processing-status,
			.success-status,
			.error-status {
				gap: 15px;
				
				p {
					font-size: 14px;
				}
			}
			
			.file-info {
				padding: 10px;
				font-size: 13px;
			}
		}
	}
</style>